// extracted by mini-css-extract-plugin
export default {"selectorGrid":"styles_selectorGrid__22mrp","gridCell":"styles_gridCell__gBlj2"};